// @givmo/app-charity — recognising the backend's step-up refusal on a payout change (AS-WEB3).
//
// The detector lives in `@givmo/step-up` since CCM-R1-STEP-UP (every module's gated act shares it);
// payout's imports keep this path.

import { unansweredStepUpRefusal } from '@givmo/step-up';

export {
  STEP_UP_REQUIRED_ERROR_CODE,
  StepUpCancelledError,
  isStepUpCancelled,
  isStepUpRequired,
  stepUpActionOf,
} from '@givmo/step-up';

/**
 * The words a payout act's failure says when the gate failed it on a refusal nothing here could
 * answer (`unansweredStepUpRefusal`): the server's own cure, as a code-only admin is told to set up a
 * passkey (AS-PWL-2e; the cut's review, F3). Never the form's "check your details" line in its place,
 * which would send a correct account number to be edited. `undefined` for every other failure.
 */
export function unansweredRefusalLine(error: unknown): string | undefined {
  const message = unansweredStepUpRefusal(error)?.message.trim();
  return message !== undefined && message.length > 0 ? message : undefined;
}
